import { Box, Tooltip } from "@mui/material";

import {
  SYNC_STATUS,
  SyncStatus as SyncStatusValue,
} from "api/memberPortal/mailList/mailList.types";

interface SyncStatusProps {
  status: SyncStatusValue;
}

const statusMap: Record<SyncStatusValue, { color: string; text: string }> = {
  [SYNC_STATUS.PENDING]: { color: "azure.light", text: "In Progress" },
  [SYNC_STATUS.SYNCING]: { color: "azure.light", text: "In Progress" },
  [SYNC_STATUS.SYNCED]: { color: "forest.light", text: "Sync Complete" },
  [SYNC_STATUS.FAILED]: { color: "coral.light", text: "Error" },
};

const animation = {
  "&::after": {
    content: '""',
    position: "absolute",
    inset: -3,
    border: 3,
    borderColor: "azure.light",
    borderRadius: "50%",
    animation: "syncPulse 3s ease-out infinite",
  },

  "@keyframes syncPulse": {
    "0%": {
      transform: "scale(0.8)",
      opacity: 0.7,
    },
    "50%": {
      transform: "scale(2)",
      inset: -4,
      border: 1,
      opacity: 0,
    },
    "100%": {
      opacity: 0,
    },
  },
};
const SyncStatus = ({ status }: SyncStatusProps) => {
  const color = statusMap[status].color;
  const text = statusMap[status].text;

  const enableAnimation =
    status === SYNC_STATUS.PENDING || status === SYNC_STATUS.SYNCING;

  return (
    <Tooltip title={text}>
      <Box
        sx={{
          color,
          position: "relative",
          width: 10,
          height: 10,

          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            bgcolor: color,
          },

          ...(enableAnimation && animation),

          "@media (prefers-reduced-motion: reduce)": {
            "&::after": {
              animation: "none",
            },
          },
        }}
      />
    </Tooltip>
  );
};

export default SyncStatus;
